import EN from './en'
import NL from './nl'

export default {
  EN,
  NL,
}
